<template>
    <button type="button" class="sidebar-bottom-switcher" @click="switchTo('/dashboard')">
        <SidebarBottomAvatar :name="consumerName" supporting="Consumer" :image-src="avatarUrl">
            <template #trailing>
                <PhCaretRight :size="16" />
            </template>
        </SidebarBottomAvatar>
    </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { PhCaretRight } from '@phosphor-icons/vue';
import { personDisplayName } from '@privacy-bee/format/text';
import SidebarBottomAvatar from './SidebarBottomAvatar.vue';
import { useAuthStore } from '~/stores/auth';
import { usePersonStore } from '~/stores/person';

const authStore = useAuthStore();
const personStore = usePersonStore();
const router = useRouter();

// Rendered only in business mode, so the switcher surfaces the inactive
// (consumer) context as the single swap action.
const switchTo = (path: string) => {
    // Switching context must always end impersonation.
    if (personStore.impersonating) {
        personStore.endImpersonationTo(path);
        return;
    }
    router.push(path);
};

const avatarUrl = computed(() => authStore.user?.identity?.avatar_url ?? null);

const consumerName = computed(() => personDisplayName(authStore.user?.identity));
</script>

<style lang="scss" scoped>
.sidebar-bottom-switcher {
    @apply block w-full rounded no-underline bg-transparent border-0 p-0 cursor-pointer text-left;
}
</style>
